import React from "react";
import { Construction, ShieldCheck } from "lucide-react";

const ComingSoonPage = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-[#16345c] via-[#12294a] to-[#0d1b2f] text-white px-6 text-center relative overflow-hidden" data-testid="coming-soon-page">
      <div className="absolute -top-32 -right-32 w-[420px] h-[420px] rounded-full bg-[#e30613]/15 blur-[120px]" />
      <div className="absolute -bottom-40 -left-24 w-[380px] h-[380px] rounded-full bg-[#3f66b3]/20 blur-[120px]" />

      <div className="relative z-10 flex flex-col items-center">
        <span className="text-[30px] sm:text-[34px] font-black tracking-tight mb-10">
          Tele<span className="text-[#ff7e00]">borsa</span> <span className="font-light text-[#ff7e00]">HR</span>
        </span>

        <span className="w-20 h-20 rounded-2xl bg-white/5 border border-white/15 flex items-center justify-center mb-8 backdrop-blur-sm">
          <Construction size={38} className="text-[#ff9a9a]" />
        </span>

        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black leading-tight" data-testid="coming-soon-title">
          Pagina in allestimento
        </h1>
        <p className="text-base md:text-lg text-gray-300 mt-5 max-w-xl leading-relaxed">
          Stiamo lavorando per offrirti la nuova esperienza del portale HR.<br className="hidden sm:block" />
          Il sito sarà presto disponibile.
        </p>

        <div className="flex items-center gap-2 text-gray-400 text-[13px] mt-12">
          <ShieldCheck size={16} /> Gruppo Teleborsa
        </div>
      </div>
    </div>
  );
};

export default ComingSoonPage;
